"use client";

import { useEffect, useState } from "react";
import { cn } from "../../../lib/utils";

function localIsoDate(now: Date) {
	const month = String(now.getMonth() + 1).padStart(2, "0");
	const day = String(now.getDate()).padStart(2, "0");
	return `${now.getFullYear()}-${month}-${day}`;
}

export type CalendarDayNumberProps = {
	/** ISO date (YYYY-MM-DD) of the cell. */
	date: string;
	day: number;
	muted?: boolean;
};

/**
 * Day number for a calendar cell. Highlights the current day in the user's
 * timezone after hydration, keeping the rest of the calendar server-rendered.
 */
export function CalendarDayNumber({ date, day, muted = false }: CalendarDayNumberProps) {
	const [isToday, setIsToday] = useState(false);

	useEffect(() => {
		setIsToday(localIsoDate(new Date()) === date);
	}, [date]);

	return (
		<span
			className={cn(
				"flex size-6 shrink-0 items-center justify-center rounded-full font-medium text-xs",
				muted && "text-muted-foreground",
				isToday && "bg-primary font-bold text-primary-foreground"
			)}
		>
			{day}
		</span>
	);
}
